import React from 'react';
import { STATIC_INDICATION_TYPES, INDICATION_TYPES } from 'modules/taboola-common-frontend-modules/Indications';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { DMA_REPORT_ID } from '../../../modules/campaigns-reports/config/reports/dma/dmaReportId';

export const CONVERSION_DATA_EXISTS_FROM_DATE = '2022-11-01';
export const USE_WIDE_PERFORMANCE_TABLE_REPORTS = [DMA_REPORT_ID];

export const reportHistoricalConversionsUnavailableIndication = {
    staticIndicationType: STATIC_INDICATION_TYPES.PARTIAL_REPORT_DATA,
    type: INDICATION_TYPES.WARNING,
    iconTypeOverride: INDICATION_TYPES.WARNING,
    highlight: (
        <FormattedMessage
            id="app.campaign.indication.historicalConversionsUnavailableWarning.highlight"
            defaultMessage="This report includes data from the past 2 years only."
        />
    ),
    message: (
        <FormattedMessage
            id="app.campaign.indication.historicalConversionsUnavailableWarning.message"
            defaultMessage="Please select a date range within that period."
        />
    ),
};
